<nb-card
  class="integration-card"
  [class.disabled]="!data?.link"
  [alAnchor]="data?.link && !data.link.startsWith('http') ? 'integration.' + data.link : null"
  (click)="data?.link && navigate(data.link)"
>
  <nb-card-body>
    <div class="image">
      <img [src]="data.image" alt="Integration Image" />
    </div>
    <h4>{{ data?.title }}</h4>
    <p class="category">{{ data?.categories | translate }}</p>
    <p class="description">{{ data?.description | translate }}</p>
    <span *ngIf="!data?.link" class="coming-soon">COMING SOON</span>
    <div
      *ngIf="isConnected"
      class="status-badge"
      [class.status-badge--paused]="isPaused"
      [class.status-badge--idle]="isIdleSync"
    >
      <span class="pulse-dot"></span>
      <span class="status-label">{{ statusLabelKey | translate }}</span>
    </div>
    <button
      *ngIf="isCloudProvider && isConnected"
      nbButton
      ghost
      size="tiny"
      class="test-btn"
      [disabled]="testing"
      (click)="testConnection($event)"
    >
      <nb-icon [icon]="testing ? 'loader-outline' : 'checkmark-circle-outline'"></nb-icon>
      {{ (testing ? "components.integrationCard.testing" : "components.integrationCard.testConnection") | translate }}
    </button>
  </nb-card-body>
</nb-card>
